import React from "react";

export default function ShareActions({ name, id, image, creator }) {
  const url = `https://nubbiland.com/character/${id}`;
  const encodedURL = encodeURIComponent(url);
  const encodedText = encodeURIComponent(`Check out this Nubbi: ${name}`);

  return (
    <div style={{ marginTop: 30, textAlign: "center" }}>
      <h3 style={{ fontSize: "1.1rem", marginBottom: 10 }}>Actions for this Nubbi</h3>
      <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: 12 }}>
    
        <a href={`https://wa.me/?text=${encodedText}%20${encodedURL}`} target="_blank" rel="noopener noreferrer" style={btnStyle("#25D366")}>WhatsApp</a>
        <a href={`https://www.facebook.com/sharer/sharer.php?u=${encodedURL}`} target="_blank" rel="noopener noreferrer" style={btnStyle("#1877F2")}>Facebook</a>
        <a href={`mailto:?subject=Check this Nubbi&body=${encodedText}%0A${url}`} style={btnStyle("#D44638")}>Email</a>
        <button onClick={() => navigator.clipboard.writeText(url)} style={btnStyle("#6B7280")}>Copy Link</button>
        <button onClick={() => alert("Download the image and upload it manually to Instagram.")} style={btnStyle("#C13584")}>Instagram</button>

  
        <button style={btnStyle("#FBBF24")}>❤️ Add to my faves</button>
        <button style={btnStyle("#8B5CF6")}>📁 Add to my page</button>
        <button style={btnStyle("#9CA3AF")}>🚫 Hide forever</button>
        <button style={btnStyle("#4B5563")}>💬 Comment</button>
        <button style={btnStyle("#10B981")}>⭐ NUBBI FEATURED</button>
        <button style={btnStyle("#3B82F6")}>👤 Follow creator</button>
        <button style={btnStyle("#0EA5E9")}>🧑‍🎨 View creator</button>
        <button style={btnStyle("#EF4444")}>🛍️ Buy merch</button>
      </div>
    </div>
  );
}

const btnStyle = (bg) => ({
  backgroundColor: bg,
  color: "#fff",
  border: "none",
  borderRadius: 8,
  padding: "8px 14px",
  fontSize: "0.9rem",
  cursor: "pointer",
  minWidth: 110,
});